module.exports = __webpack_public_path__ + "img/icon_point.41a0839a.svg";